import { render, staticRenderFns } from "./tongueApiStatistics.vue?vue&type=template&id=4782577c&scoped=true"
import script from "./tongueApiStatistics.vue?vue&type=script&lang=ts"
export * from "./tongueApiStatistics.vue?vue&type=script&lang=ts"
import style0 from "./tongueApiStatistics.vue?vue&type=style&index=0&id=4782577c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4782577c",
  null
  
)

export default component.exports